import { isFirefox, isCompatibleChrome } from "./tool";

const Agora =  class Agora {
    
    constructor(configBaseOption, roleType) {
        // 基础配置项：
        this.configBaseOption = configBaseOption;
        // 角色类型：1:老师  2:学生
        this.roleType = roleType;
        // client:
        this.agoraClient = null;
        // stream:
        this.screenStream = null;
    }

    // 声网初始化：
    agoraInit() {
        AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.INFO);
        let agoraClient = AgoraRTC.createClient({
            mode: 'live', // live rtc
            codec: 'h264' // h264 vp8
        });
        this.agoraClient = agoraClient;
        let { appId } = this.configBaseOption;
        agoraClient.init(appId, () => {
            // 1、加入之前先退出：
            this.leave();
            // 2、加入之前设置角色：
            this.setClientRole();
            // 3、然后再加入：
            this.join();
        });
    }

    // 离开频道。
    // 离开频道即挂断或退出通话。
    // 调用该方法离开频道时，本地会触发 AgoraRTCClient.on("connection-state-change") 回调。
    // 通信场景下的用户和直播场景下的主播离开频道后，远端会触发 AgoraRTCClient.on("user-left") 回调。
    leave() {
        this.agoraClient.leave(function() {
            console.log("leaves channel success");
        }, function(err) {
            console.log(err, "leaves channel error");
        });
    }

    // 设置用户角色
    // 本方法仅适用于直播场景。
    // 直播场景下，可以调用本方法设置用户角色。
    // 在加入频道前，用户可以通过本方法设置自己的角色。
    // 在加入频道后，用户可以通过本方法切换角色：
    // 用户在调用 publish 的时候会自动切换成 host 角色，调用 unpublish 的时候会自动切换为 audience 角色。
    // 如果已经调用了 publish，调用本方法将用户角色设置为 audience，会自动进行 unpublish。
    // 如果你在加入频道后调用该方法切换用户角色，切换成功后，本地会触发 Client.on("client-role-changed") 回调；远端会触发 Client.on("peer-online") 或者 Client.on("peer-leave") 回调。
    // 通信场景（mode 设置为 rtc）无法使用本方法，默认所有用户都是 host 角色。
    setClientRole() {
        let roleRes = "";
        switch(this.roleType) {
            case 1:
                roleRes = 'host';
                break;
            case 2:
                roleRes = 'audience';
                break;
        }
        this.agoraClient.setClientRole(roleRes, function(e) {
            if (!e) {
                console.log("set role success");
            } else {
                console.log("set role error", e);
            }
        });
    }

    // 加入频道。
    // 该方法让用户加入通话频道，在同一个频道内的用户可以互相通话。
    // 调用该方法加入频道时，本地会触发 AgoraRTCClient.on("connection-state-change") 回调。
    // 通信场景下的用户和直播场景下的主播加入频道后，远端会触发 AgoraRTCClient.on("user-joined") 回调。
    join() {
        let { token, channelId, userId } = this.configBaseOption;
        this.agoraClient.join(
            token,
            channelId,
            userId,
            uid => {
              // ...
            },
            err => {
              // "UID_CONFLICT": 当前 Client 的 uid 和频道中其他 Client 的 uid 冲突
              console.log(err, "join channel error");
            }
        )
    }

    // 在publish发布音视频流之后，
    // 本地会触发 Client.on("stream-published") 回调；
    // 远端会触发 Client.on("stream-added") 回调。
    watchStreamPublished(cb) {
        this.agoraClient.on('stream-published', e => {
            cb && cb();
        });
    }

    watchStreamAdded(cb) {
        this.agoraClient.on('stream-added', e => {
            console.log('stream-added');
            let stream = e.stream;
            //设置视频音量静音
            // stream.setAudioVolume(0);
            // let uid = stream.getId();
            cb && cb(e);
            this.agoraClient.subscribe(stream, { video: true, audio: true }, err => {
                console.log(err, "订阅失败subscribe");
            });
        });
    }

    // 订阅远端音视频流之后，
    // 本地会触发 Client.on("stream-subscribed") 回调
    watchStreamSubscribed(cb) {
        this.agoraClient.on('stream-subscribed', e => {
            cb && cb(e);
        });
    }

    // 在unpublish取消发布音视频流之后，
    // 本地会触发 Client.on("stream-unpublished") 回调，
    // 远端会触发 Client.on("stream-removed") 回调。
    watchStreamUnpublished(cb) {
        this.agoraClient.on("stream-unpublished", () => {
            cb && cb();
        });
    }

    watchStreamRemoved(cb) {
        this.agoraClient.on('stream-removed', e => {
            cb && cb(e);
        });
    }

    // 创建屏幕流：
    screenStreamInit(cb) {
        let { userId, channelId } = this.configBaseOption;
        // 创建屏幕共享流
        let streamSpec = {
            streamID: userId,
            audio: false,
            video: false,
            screen: true,
            screenAudio: false
        }
        // 根据浏览器类型设置相关属性
        // 注意你需要自己实现判断浏览器的功能
        if (isFirefox()) {
            streamSpec['mediaSource'] = 'window';
        } else if (!isCompatibleChrome()) {
            streamSpec['extensionId'] = 'minllpmhdgpndnkomcoccfekfegnlikg';
        }
        let screenStream = AgoraRTC.createStream(streamSpec);
        // 屏幕视频属性必须在初始化流 (Stream.init) 之前设置。
        // screenStream.setScreenProfile("720p_1"); // 720p_1 720p_2 1080p_1 1080p_2
        // NotFoundError: 找不到指定的媒体流。检查你的麦克风和摄像头是否正常工作。
        // NotAllowedError: 用户拒绝授予对应的摄像头或麦克风权限。
        // 初始化流
        // 调用 screenStream.init ，SDK 会提供自带的默认界面让用户选择要共享的屏幕或窗口
        screenStream.init(
            () => {
                screenStream.setVideoEncoderConfiguration({
                    // 视频分辨率
                    resolution: {
                    width: 1920,
                    height: 1080
                    },
                    // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
                    frameRate: {
                    min: 10,
                    max: 30
                    },
                    // 码率。一般情况下推荐使用标准码率
                    bitrate: {
                    min: 250,
                    max: 400
                    }
                });
                // 播放流
                // screenStream.play('Screen');
                // 发布流
                this.agoraClient.publish(screenStream);
            },
            err => {
                console.log(err, "screenStream init error");
                cb && cb(err);
            }
        );
        this.screenStream = screenStream;
    }

    // 在unpublish取消发布音视频流之后，
    // 本地会触发 Client.on("stream-unpublished") 回调，
    // 远端会触发 Client.on("stream-removed") 回调。
    unpublish() {
        this.agoraClient.unpublish(this.screenStream, err => {
            // "STREAM_NOT_YET_PUBLISHED": 指定的 stream 还没有发布。
            // INVALID_OPERATION: 非法操作。该错误通常是重复加入频道引起的，请确保重复加入时先调用leave。
            console.log(err, "unpublish error");
        });
    }

    // 该回调通知应用屏幕共享已停止。
    stopScreenSharing(cb) {
        this.screenStream.on("stopScreenSharing", e => {
            console.log("stopScreenSharing");
            cb && cb();
        })
    }

    // 获取远端订阅流的视频统计数据
    // 获取远端订阅流的视频统计数据
    // 该方法获取远端订阅流的视频统计数据，包括丢包率、视频码率、视频帧率等。
    // 统计数据需要在 stream-subscribed 事件后进行统计，可能耗费 0-3 秒时间返回。你可以循环调用该方法获取数据。
    getRemoteVideoStats (cb) {
        this.agoraClient.getRemoteVideoStats(remoteVideoStatsMap => {
        cb && cb(remoteVideoStatsMap)
        })
    }

    // 获取当前会话的统计数据
    // 获取与会话的连接状况统计数据
    // 该方法获取与会话的连接状况统计数据。
    // 本方法需要在加入频道成功后调用，统计数据可能耗费 0-3 秒时间返回。你可以循环调用该方法获取数据。
    getSessionStats (cb) {
        this.agoraClient.getSessionStats(stats => {
            cb && cb(stats)
        })
    }

    enableAudioVolumeIndicator (cb) {
        this.agoraClient.enableAudioVolumeIndicator()
        this.agoraClient.on('volume-indicator', function (evt) {
          cb && cb(evt)
        })
      }

    // 订阅远端音视频流
    subscribeAllStreamTeach(streamId){
        this.streamAddedListener((evt)=> {
            let option={video: true, audio: true};
            if(this.rtc.isSafari){
                option=null;
            }
            var remoteStream = evt.stream;
            if(remoteStream.getId()==streamId){
                this.rtc.client.subscribe(remoteStream,option,(err)=> {
                    console.error("stream subscribe failed", err);
                });
            }
        });
    }
    /**
     * 监听:远端流加入
     */
     streamAddedListener(call) {
        this.rtc.client.on("stream-added", (evt) => {
            var remoteStream = evt.stream;
            //设置视频音量静音
            remoteStream.setAudioVolume(0);
            var id = remoteStream.getId();
            console.log(id, 666666666);
            this.rtc.remoteStreams.set(id, remoteStream);
            call && call()
        });
    }

}

export default Agora;